import { useAddElementSkeletonTracker } from "../../../context/addElementSkeletonContext";
import { V3Button } from "../../Button";
import { V3ButtonColor } from "../../Button/V3Button.types";
import { RightAlignPanel } from "../../ReusableStyledComponents/RightAlignPanel";
import { VerticalSpacing } from "../../VerticalSpacing";
import { SourceAddedPanel, SourceAddedSVG, SourceAddedHeadline } from "./AddSource.styles";

import type { JSX } from "react";

interface AddSourceCompletedProps {
    onCloseHandler: () => void;
    title: string;
    description: JSX.Element;
    showAddMoreContent?: boolean;
}

export const AddSourceCompleted = ({ onCloseHandler, title, description, showAddMoreContent = true }: AddSourceCompletedProps) => {
    const { setAddContentOpen } = useAddElementSkeletonTracker();

    return (
        <>
            <SourceAddedPanel>
                <VerticalSpacing bottom={24}>
                    <SourceAddedSVG width="252" height="60" viewBox="0 0 252 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="252" height="60" fill="white" />
                        <path
                            d="M30 56.25C44.4975 56.25 56.25 44.4975 56.25 30C56.25 15.5025 44.4975 3.75 30 3.75C15.5025 3.75 3.75 15.5025 3.75 30C3.75 44.4975 15.5025 56.25 30 56.25Z"
                            stroke="#ABB0BA"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path d="M3.75 22.5H56.25" stroke="#ABB0BA" strokeWidth="3" strokeLinejoin="round" />
                        <path d="M3.75 37.5H56.25" stroke="#ABB0BA" strokeWidth="3" strokeLinejoin="round" />
                        <path
                            d="M30 3.75C22.6478 11.6239 18.75 20.7188 18.75 30C18.75 39.2812 22.6478 48.3761 30 56.25"
                            stroke="#ABB0BA"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M30 3.75C37.3522 11.6239 41.25 20.7188 41.25 30C41.25 39.2812 37.3522 48.3761 30 56.25"
                            stroke="#ABB0BA"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M198.637 29.9998C198.637 43.9861 210.015 55.3647 224.001 55.3647C237.988 55.3647 249.366 43.9861 249.366 29.9998C249.366 16.0141 237.988 4.63542 224.001 4.63542C210.015 4.63542 198.637 16.0141 198.637 29.9998ZM196 29.9997C196 14.5362 208.536 2 224 2C239.464 2 252 14.5362 252 29.9997C252 45.4638 239.464 58 224 58C208.536 58 196 45.4638 196 29.9997ZM224 24.2368C225.09 24.2368 225.976 23.3501 225.976 22.2603C225.976 21.1706 225.09 20.2839 224 20.2839C222.91 20.2839 222.023 21.1706 222.023 22.2603C222.023 23.3501 222.91 24.2368 224 24.2368ZM229.878 28.488L227.793 24.8763C226.961 26.0806 225.571 26.8719 224 26.8719C222.428 26.8719 221.04 26.0806 220.206 24.8763L218.121 28.488C219.704 29.9829 221.801 30.8249 224 30.8249C226.2 30.8249 228.296 29.9829 229.878 28.488ZM210.877 41.0355H207.835L224 13.0352L240.166 41.0355H237.123L231.225 30.819C229.217 32.5142 226.667 33.4602 224 33.4602C221.334 33.4602 218.783 32.5135 216.776 30.819L210.877 41.0355Z"
                            fill="#ABB0BA"
                        />
                        <circle cx="81.5" cy="30.5" r="3.5" fill="#ABB0BA" />
                        <circle cx="112.5" cy="30.5" r="3.5" fill="#DDDFE3" />
                        <circle cx="143.5" cy="30.5" r="3.5" fill="#F4F4F6" />
                        <circle cx="174.5" cy="30.5" r="3.5" fill="#FAFAFA" />
                    </SourceAddedSVG>
                </VerticalSpacing>
                <VerticalSpacing bottom={24}>
                    <SourceAddedHeadline style={{ textAlign: "center" }}>{title}</SourceAddedHeadline>
                </VerticalSpacing>
                <VerticalSpacing bottom={32}>{description}</VerticalSpacing>
            </SourceAddedPanel>
            <RightAlignPanel>
                <div>
                    <V3Button text="Close" onClick={onCloseHandler} color={V3ButtonColor.secondary} />
                </div>
                {showAddMoreContent && (
                    <div>
                        <V3Button
                            text="Add more content"
                            onClick={() => {
                                setAddContentOpen(false);
                                setTimeout(() => {
                                    setAddContentOpen(true);
                                }, 100);
                            }}
                        />
                    </div>
                )}
            </RightAlignPanel>
        </>
    );
};
